import { render, staticRenderFns } from "./YouTubeClickToLoad.vue?vue&type=template&id=33a6686b&scoped=true"
import script from "./YouTubeClickToLoad.vue?vue&type=script&lang=js"
export * from "./YouTubeClickToLoad.vue?vue&type=script&lang=js"
import style0 from "./YouTubeClickToLoad.vue?vue&type=style&index=0&id=33a6686b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a6686b",
  null
  
)

export default component.exports